import "./Hero.css";
export default function Hero({ title, subtitle, ctaText, ctaHref, youtube }) {
  return (
    <section className="hero">
      {youtube && (
        <div className="hero-video-wrapper">
          <iframe
            className="hero-video"
            src={`https://www.youtube.com/embed/${youtube}?autoplay=1&mute=1&loop=1&playlist=${youtube}&end=45`}
            title="Hero Video"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        </div>
      )}

      <div className="hero-overlay">
        <h1>{title}</h1>
        {subtitle && <p className="hero-sub">{subtitle}</p>}
        {ctaText && <a className="btn" href={ctaHref}>{ctaText}</a>}
      </div>
    </section>
  );
}
